import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=f224a0fa&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=ts"
export * from "./ReportDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=f224a0fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f224a0fa",
  null
  
)

export default component.exports